import { Alert } from '@/global/components/Alert'
import Grid from '@/global/components/ui/Grid'
import { cn } from '@/lib/utils'
import { FormField } from 'global/components/Form'
import { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import { TabelaHorarios } from 'service/api'
import { useCanSubmit } from '../context/CanSubmitContext'
import { camposIgnorados, tipoTolerancia } from '../utils/tipo-tolerancia'

export function ToleranciasForm() {
    const { setValue, watch, formState } = useFormContext<TabelaHorarios>()
    const { setCanSubmit } = useCanSubmit()
    const { errors } = formState

    /** Tolerância é informada em minutos: mantém no campo apenas dígitos */
    function onChange(field: any) {
        return function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
            const limpo = e.target.value.replace(/\D/g, '')

            if (limpo !== e.target.value) setValue(field, limpo)
        }
    }

    const defaultProps = {
        size: 'small' as const,
        InputLabelProps: { shrink: true },
        type: 'text',
        inputProps: { inputMode: 'numeric' as const },
        placeholder: '0',
        required: true,
        onFocus: () => setCanSubmit(false),
        onBlur: () => setCanSubmit(true),
    }

    const [tipo, turno, dia] = watch([
        'tipo',
        'tolerancias.toleranciaTurno',
        'tolerancias.toleranciaDia',
    ])

    const disabled = useMemo(
        () =>
            camposIgnorados[
                tipoTolerancia({
                    tipo,
                    tolerancias: {
                        toleranciaTurno: turno,
                        toleranciaDia: dia,
                    },
                })
            ],
        [tipo, turno, dia],
    )

    // Verificar se há erro relacionado a tolerâncias
    const erroTolerancia =
        errors.tolerancias?.toleranciaDia?.message ||
        errors.tolerancias?.toleranciaTurno?.message ||
        errors.tolerancias?.entradaAntes?.message ||
        errors.tolerancias?.entradaDepois?.message ||
        errors.tolerancias?.saidaAntes?.message ||
        errors.tolerancias?.saidaDepois?.message ||
        errors.tolerancias?.root?.message

    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={2}>
                    <FormField
                        {...defaultProps}
                        name="tolerancias.entradaAntes"
                        unHelperText
                        onChange={onChange('tolerancias.entradaAntes')}
                        label={
                            <span
                                className={cn({
                                    'line-through':
                                        disabled.includes('registros'),
                                })}
                            >
                                De entrada antes
                            </span>
                        }
                        className={cn({
                            'line-through': disabled.includes('registros'),
                        })}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormField
                        {...defaultProps}
                        name="tolerancias.entradaDepois"
                        unHelperText
                        onChange={onChange('tolerancias.entradaDepois')}
                        label={
                            <span
                                className={cn({
                                    'line-through':
                                        disabled.includes('registros'),
                                })}
                            >
                                De entrada depois
                            </span>
                        }
                        className={cn({
                            'line-through': disabled.includes('registros'),
                        })}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormField
                        {...defaultProps}
                        name="tolerancias.saidaAntes"
                        unHelperText
                        onChange={onChange('tolerancias.saidaAntes')}
                        label={
                            <span
                                className={cn({
                                    'line-through':
                                        disabled.includes('registros'),
                                })}
                            >
                                De saída antes
                            </span>
                        }
                        className={cn({
                            'line-through': disabled.includes('registros'),
                        })}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormField
                        {...defaultProps}
                        name="tolerancias.saidaDepois"
                        unHelperText
                        onChange={onChange('tolerancias.saidaDepois')}
                        label={
                            <span
                                className={cn({
                                    'line-through':
                                        disabled.includes('registros'),
                                })}
                            >
                                De saída depois
                            </span>
                        }
                        className={cn({
                            'line-through': disabled.includes('registros'),
                        })}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormField
                        {...defaultProps}
                        name="tolerancias.toleranciaTurno"
                        onChange={onChange('tolerancias.toleranciaTurno')}
                        unHelperText
                        label={
                            <span
                                className={cn({
                                    'line-through': disabled.includes('turno'),
                                })}
                            >
                                Por turno
                            </span>
                        }
                        className={cn({
                            'line-through': disabled.includes('turno'),
                        })}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormField
                        {...defaultProps}
                        name="tolerancias.toleranciaDia"
                        unHelperText
                        onChange={onChange('tolerancias.toleranciaDia')}
                        label={
                            <span
                                className={cn({
                                    'line-through': disabled.includes('dia'),
                                })}
                            >
                                Por dia
                            </span>
                        }
                        className={cn({
                            'line-through': disabled.includes('dia'),
                        })}
                    />
                </Grid>
                {erroTolerancia && (
                    <Grid item xs={12} className="my-2">
                        <Alert severity="error">{erroTolerancia}</Alert>
                    </Grid>
                )}
            </Grid>
        </>
    )
}
